import { render, staticRenderFns } from "./ReportSection.vue?vue&type=template&id=492a384a&scoped=true"
import script from "./ReportSection.vue?vue&type=script&lang=js"
export * from "./ReportSection.vue?vue&type=script&lang=js"
import style0 from "./ReportSection.vue?vue&type=style&index=0&id=492a384a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492a384a",
  null
  
)

export default component.exports